import React from 'react';
import { connect } from 'react-redux';
import { TextInputField } from '@ff-os/shared-react/components/input/text-input/TextInputField';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectContentById, selectMaxLengthById, updateContentByIds } from '../_redux';

const _TextInputControlField = ({
    value, onChange, maxLength
}: Props) => (
    <TextInputField value={value} commit={onChange} maxLength={maxLength} />
);

type Props = {
    variableIds: string[];
    maxLength: number;
    value: string;
    onChange: (value: string) => void;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    maxLength: selectMaxLengthById(state, ownProps.variableIds[0]!)!,
    value: selectContentById(state, ownProps.variableIds[0])!
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch, ownProps: { variableIds: string[] }) => ({
    onChange: (value: string) => dispatch(updateContentByIds(ownProps.variableIds, value))
});

export const TextInputControlField = connect(
    mapStateToProps,
    mapDispatchToProps
)(_TextInputControlField);